import React, { Component, Fragment } from 'react';
import { Filter, Main } from 'Containers/';
import { connect } from 'react-redux';

import { withRouter } from 'react-router';
import { LettersForm } from './components/LettersForm';
import moment from 'moment';
import { LettersFieldEnum as Fields } from 'Common/FieldEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { LETTERS_FORM_NAME } from 'Common/FormEnum';
import {
  fetchInitialData,
  processLetters,
  clearBadEmails,
  clearError,
} from './state/letters/actions';
import { LoadingPage, YesNoDialog } from 'Components/';
import { toastType, createToast } from 'Common/ToastHelper';
import _ from 'lodash';
import { getSelectedStatuses, POSLetterTypeEnum } from './helpers/helpers';
import { StatusEnum } from 'Common/Constants/Enumeration/StatusEnum';

class LettersContainer extends Component {
  state = {
    showEmailConfirm: false,
    emailConfirmed: false,
    emailSubmit: null,
  };

  componentDidMount() {
    this.props.fetchInitialData();
  }

  componentDidUpdate(prevProps, prevState) {
    const { error } = this.props;

    if (error) {
      for (let x = 0; x < error.length; x++) {
        var title = _.get(error[x], 'Title', 'Error');
        var msg = _.get(error[x], 'Message', '');
        createToast(toastType.error, title, msg, true);
      }
      this.props.clearError();
    }
  }

  getMainProps = () => {
    return {
      toolbox: {
        formName: LETTERS_FORM_NAME,
        saveButtonProps: {
          content: 'Process',
          loading: this.props.loading,
        },
        shown: true,
      },
    };
  };

  handleSubmit = formValues => {
    const data = {
      ...formValues,
      MealStatuses: getSelectedStatuses(formValues),
    };

    if (_.get(data, 'MealStatuses', []).length === 0) {
      createToast(toastType.error, 'Error', 'Meal Status required!', true);
      return;
    }

    if (_.get(formValues, 'PrintType', 0) === 1 && !this.state.emailConfirmed) {
      this.setState({ showEmailConfirm: true });
      return;
    }

    this.setState({ emailConfirmed: false });

    this.props.processLetters(data);
  };

  statusCheckboxes = () => {
    return Object.values(StatusEnum)
      .filter(f => f !== '0')
      .map(value => ({
        name: `Statuses${value}`,
        label: value,
        checked: true,
      }));
  };

  emailSubmit = funct => {
    this.setState({ emailSubmit: funct });
  };

  getBadEmailCount = letterTypeEnum => {
    switch (letterTypeEnum) {
      case POSLetterTypeEnum.Student:
        return _.get(this.props, 'badStudentEmailsHistIds', []).length;
      case POSLetterTypeEnum.Teacher:
        return _.get(this.props, 'badTeacherEmailsHistIds', []).length;
      case POSLetterTypeEnum.LowBalance:
        return _.get(this.props, 'badLowBalanceEmailsHistIds', []).length;
      default:
        return 0;
    }
  };

  getBadEmailQuestion = letterTypeEnum => {
    var badCount = this.getBadEmailCount(letterTypeEnum);
    var letterDesc = '';

    switch (letterTypeEnum) {
      case POSLetterTypeEnum.Student:
        letterDesc = 'Student Bill';
        break;
      case POSLetterTypeEnum.Teacher:
        letterDesc = 'Teacher Bill';
        break;
      case POSLetterTypeEnum.LowBalance:
        letterDesc = 'Low Balance';
        break;
      default:
    }

    const plural = badCount > 1 ? 's' : '';
    const wasWere = badCount > 1 ? 'were' : 'was';
    const badEmailAddressDesc =
      badCount > 1 ? 'bad email addresses' : 'a bad email address';
    const thisThese = badCount > 1 ? 'these' : 'this';
    var title = `[${badCount}] ${letterDesc} email${plural} ${wasWere} returned due to ${badEmailAddressDesc}.`;
    var title2 = `Do you want to print ${thisThese} letter${plural}?`;
    return (
      <span>
        {title}
        <br />
        {title2}
      </span>
    );
  };

  getYesNoModal = letterTypeEnum => {
    var bShow = this.getBadEmailCount(letterTypeEnum) > 0;
    var title = '';

    switch (letterTypeEnum) {
      case POSLetterTypeEnum.Student:
        title = 'Student Bill has failed email(s).';
        break;
      case POSLetterTypeEnum.Teacher:
        title = 'Teacher Bill has failed email(s).';
        break;
      case POSLetterTypeEnum.LowBalance:
        title = 'Low Balance has failed email(s).';
        break;
      default:
    }

    return (
      <YesNoDialog
        showDialog={bShow}
        title={title}
        question={this.getBadEmailQuestion(letterTypeEnum)}
        yesCallback={() => {
          return this.acceptToPrintFailedEmails(letterTypeEnum);
        }}
        noCallback={() => {
          return this.declineToPrintFailedEmails(letterTypeEnum);
        }}
      />
    );
  };

  declineToPrintFailedEmails = letterTypeEnum => {
    var histIds = [];
    switch (letterTypeEnum) {
      case POSLetterTypeEnum.Student:
        histIds = this.props.badStudentEmailsHistIds;
        break;
      case POSLetterTypeEnum.Teacher:
        histIds = this.props.badTeacherEmailsHistIds;
        break;
      case POSLetterTypeEnum.LowBalance:
        histIds = this.props.badLowBalanceEmailsHistIds;
        break;
      default:
    }

    const data = {
      POSletterType: letterTypeEnum,
      IsPOSLetterHistory: true,
      letterHistoryIds: histIds,
    };
    this.props.clearBadEmails(data);
  };

  acceptToPrintFailedEmails = letterTypeEnum => {
    var histIds = [];
    switch (letterTypeEnum) {
      case POSLetterTypeEnum.Student:
        histIds = this.props.badStudentEmailsHistIds;
        break;
      case POSLetterTypeEnum.Teacher:
        histIds = this.props.badTeacherEmailsHistIds;
        break;
      case POSLetterTypeEnum.LowBalance:
        histIds = this.props.badLowBalanceEmailsHistIds;
        break;
      default:
    }

    const data = {
      POSletterType: letterTypeEnum,
      IsPOSLetterHistory: true,
      IsPrintBadEmails: true,
      BadEmailLetterHistoryIds: histIds,
    };
    this.props.processLetters(data);
  };

  acceptToPrintEmails = () => {
    this.setState(
      {
        showEmailConfirm: false,
        emailConfirmed: true,
      },
      this.state.emailSubmit
    );
  };

  declineToPrintEmails = () => {
    this.setState({ showEmailConfirm: false, emailConfirmed: false });
  };

  initialValues = () => {
    let initialValues = {
      [Fields.SortByType]: 0,
      [Fields.PrintType]: 0,
      [Fields.LetterType]: 0,
      [Fields.SiteId]: 'ALL',
      [Fields.GradeId]: 'ALL',
      [Fields.Balance1]: '0.00',
      [Fields.Balance2]: '0.00',
      [Fields.LetterDate]: defaultDateFormat(moment()),
    };

    this.statusCheckboxes().forEach(x => {
      Object.defineProperty(initialValues, `${x.name}`, {
        value: x.checked,
        writable: true,
        enumerable: true,
      });
    });

    return initialValues;
  };

  render() {
    const { loading } = this.props;

    return (
      <Fragment>
        {loading ? <LoadingPage message={'Loading'} /> : undefined}

        <Filter title={'Letters'} />
        <Main {...this.getMainProps()}>
          <LettersForm
            onSubmit={this.handleSubmit}
            onEmailSubmit={this.emailSubmit}
            statusCheckboxes={this.statusCheckboxes()}
            initialValues={this.initialValues()}
          />
        </Main>
        <YesNoDialog
          showDialog={this.state.showEmailConfirm}
          title={'Email Letters?'}
          question={
            <span>
              Emails will immediately be sent to parents/guardians; there is no
              preview before they send.
              <br />
              Do you wish to continue?
            </span>
          }
          yesCallback={this.acceptToPrintEmails}
          noCallback={this.declineToPrintEmails}
        />

        {loading === false
          ? this.getBadEmailCount(POSLetterTypeEnum.Student) > 0
            ? this.getYesNoModal(POSLetterTypeEnum.Student)
            : this.getBadEmailCount(POSLetterTypeEnum.Teacher) > 0
            ? this.getYesNoModal(POSLetterTypeEnum.Teacher)
            : this.getBadEmailCount(POSLetterTypeEnum.LowBalance) > 0
            ? this.getYesNoModal(POSLetterTypeEnum.LowBalance)
            : undefined
          : undefined}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { report } = state.LettersState;

  return {
    loading: report.loading,
    grades: report.grades,
    error: report.error,
    badStudentEmailsHistIds: report.badStudentEmailsHistIds,
    badTeacherEmailsHistIds: report.badTeacherEmailsHistIds,
    badLowBalanceEmailsHistIds: report.badLowBalanceEmailsHistIds,
  };
};

export const Letters = withRouter(
  connect(
    mapStateToProps,

    { fetchInitialData, processLetters, clearBadEmails, clearError }
  )(LettersContainer)
);



// WEBPACK FOOTER //
// ./src/pages/letters/Letters.js